// Vendors
import { takeLatest, put, call, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';

// Slice
import {
  fetchTransactionInfoFailure,
  fetchTransactionInfoStart,
  fetchTransactionInfoSuccess,
} from './transactionSlice';

// Models
import { TransactionService } from '@services/transactionService';
import { TransactionDetails, TransationInfoPayload } from '@models/Transaction';
import { APIResponse } from '@/api/types';

// Sage to fetch invoice list
function* fetchTransactionInfo(
  action: PayloadAction<TransationInfoPayload>
): Generator<
  CallEffect<APIResponse<TransactionDetails>> | PutEffect,
  void,
  APIResponse<TransactionDetails>
> {
  try {
    const invoiceList: APIResponse<TransactionDetails> = yield call(
      TransactionService.fetchTransactionInfo,
      action.payload
    );
    yield put(fetchTransactionInfoSuccess(invoiceList));
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Failed';
    yield put(fetchTransactionInfoFailure(errorMessage));
  }
}

// Watcher Sagas
export function* watchTransaction(): SagaIterator {
  yield takeLatest(fetchTransactionInfoStart.type, fetchTransactionInfo);
}
